module.exports = __webpack_public_path__ + "static/img/jyfw.9153832.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/jyfw.png
// module id = sSfM
// module chunks = 1